/**
 * Friendly labels for tool activity — the stream narrates work in verbs
 * ("Searching procurement…") instead of raw tool names (procurement_search).
 */
const TOOL_LABELS = {
  procurement_search: 'Searching procurement',
  spend_analysis: 'Analyzing spend',
  department_summary: 'Summarizing departments',
  classification_quality: 'Checking classification quality',
  classification_methods: 'Checking classification methods',
  classification_suspects: 'Finding classification suspects',
  review_queue: 'Checking review queue',
  component_lookup: 'Looking up components',
  scraper_status: 'Checking scraper status',
  scraper_jobs: 'Checking scraper jobs',
  health_check: 'Checking server health',
  get_renewals: 'Checking renewals',
  get_competitive_footprint: 'Mapping competitive footprint',
  ask_user: 'Asking you',
  atlas_get_capability_config: 'Fetching capability config',
  atlas_analyze_framework_gaps: 'Analyzing framework gaps',
  atlas_search_by_capability: 'Searching capabilities',
  atlas_deep_dive_documentation: 'Reading documentation',
  atlas_compare_competitive: 'Comparing competitors',
  atlas_list_capabilities: 'Browsing capabilities',
  atlas_list_products: 'Browsing products',
  get_my_feed: 'Checking intelligence feed',
  what_should_i_know: 'Building briefing',
  get_account_brief: 'Building account brief',
  get_my_digests: 'Fetching digests',
  mark_feed_item_read: 'Marking item read',
  dismiss_feed_item: 'Dismissing item',
  save_feed_item: 'Saving item',
  create_task: 'Creating task',
  list_tasks: 'Listing tasks',
  complete_task: 'Completing task',
  update_task: 'Updating task',
  delete_task: 'Deleting task',
  what_am_i_forgetting: 'Checking reminders',
  calendar_status: 'Checking calendar connection',
  calendar_events: 'Reading calendar',
  calendar_free_slots: 'Finding free slots',
  calendar_schedule: 'Scheduling',
  render_ui: 'Building visual',
  web_search: 'Searching the web',
  save_customer_note: 'Filing note',
  search_customer_notes: 'Searching notes',
  save_contact: 'Saving contact',
  get_contacts: 'Looking up contacts',
  save_meeting: 'Saving meeting',
  list_meetings: 'Checking meetings',
  save_draft: 'Saving draft',
  list_drafts: 'Checking drafts',
  save_opportunity: 'Recording opportunity',
  list_opportunities: 'Checking pipeline',
  save_presentation: 'Building presentation',
  list_presentations: 'Checking presentations',
  list_artifacts: 'Checking saved views',
  get_artifact: 'Loading saved view',
};

export function friendlyToolLabel(name) {
  if (!name) return '';
  return TOOL_LABELS[name] || name.replace(/^atlas_/, '').replace(/_/g, ' ');
}

export default friendlyToolLabel;
